import { Anchor, Checkbox, Tooltip, useCheckboxState } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useWatchAlias } from 'hooks'
import { useEffect, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useFormStateContext } from '../../../../providers'
import { FormAliasKeys } from '../../../../providers/useFormAlias.constate'
import { messages } from './messages'

interface Props {
  name: string
}

export function Accumulate(props: Props) {
  const { name } = props
  const { $t } = useIntl()
  const { form, readOnly } = useFormStateContext()
  const accumulate: boolean = useWatch({ form, name })

  const state = useCheckboxState({ initialValue: accumulate })

  const benefitType = useWatchAlias<string>({
    key: FormAliasKeys.benefitType,
    form,
  })

  const benefitIsCompatible = useMemo(() => {
    return benefitType !== 'priceTable'
  }, [benefitType])

  useEffect(() => {
    if (!benefitIsCompatible && form.getValues(name)) {
      form.setValue(name, false)
      state.setValue(false)
    }
  }, [benefitIsCompatible, form, name, state])

  return (
    <Tooltip
      text={$t(messages.accumulate.tooltip)}
      placement="top"
      visible={benefitIsCompatible ? false : undefined}
    >
      <div data-testid="accumulate-container">
        <Checkbox
          state={state}
          disabled={readOnly || !benefitIsCompatible}
          label={$t(messages.accumulate.label)}
          helpText={$t(messages.accumulate.helpText, {
            a: (content: any) => (
              <Anchor
                target="_blank"
                href={$t(messages.accumulate.moreInformation)}
              >
                {content}
              </Anchor>
            ),
          })}
          onChange={({ target: { checked } }) => {
            form.setValue(name, checked)
          }}
        />
      </div>
    </Tooltip>
  )
}
